<script lang="ts">
  import LoaderIcon from '$icons/loaders/LoaderIcon.svelte';
  import type { HTMLAttributeAnchorTarget } from 'svelte/elements';

  export let type: 'submit' | 'button' | 'reset' = 'button';
  export let icon = false;
  export let size: 'xs' | 'sm' | 'md' = 'sm';
  export let primary = false;
  export let secondary = false;
  export let tertiary = false;
  export let quaternary = false;
  export let quinary = false;
  export let transparent = false;
  export let danger = false;
  export let disabled = false;
  export let href = '';
  export let submitting = false;
  export let loading = false;
  export let target: HTMLAttributeAnchorTarget | null = null;
  export let tabindex: number | undefined = undefined;
</script>

{#if href}
  <a
    {href}
    {target}
    class:disabled
    class:xs={size == 'xs'}
    class:sm={size == 'sm'}
    class:md={size == 'md'}
    class:primary
    class:secondary
    class:tertiary
    class:quaternary
    class:quinary
    class:transparent
    class:danger
    class:icon
    class="gap-x-sm font-architekt flex cursor-pointer items-center justify-center rounded border border-transparent text-sm font-normal leading-5 ring-[3px] ring-transparent disabled:cursor-not-allowed {$$props.class}"
  >
    <slot name="left-icon" />
    <slot />
    <slot name="right-icon" />
  </a>
{:else}
  <button
    {type}
    {disabled}
    {tabindex}
    class:xs={size == 'xs'}
    class:sm={size == 'sm'}
    class:md={size == 'md'}
    class:primary
    class:secondary
    class:tertiary
    class:quaternary
    class:quinary
    class:transparent
    class:danger
    class:icon
    class="gap-x-sm font-architekt flex cursor-pointer items-center justify-center rounded border border-transparent text-sm font-normal leading-5 ring-[3px] ring-transparent disabled:cursor-not-allowed {transparent} {$$props.class}"
    style={$$props.style}
    on:click
  >
    {#if submitting || loading}
      {#if $$slots['left-icon']}
        <LoaderIcon class="h-4 w-4" />
        <slot />
      {:else if $$slots['right-icon']}
        <slot />
        <LoaderIcon class="h-4 w-4" />
      {:else}
        <LoaderIcon class="h-4 w-4" />
      {/if}
    {:else}
      <slot name="left-icon" />
      <slot />
      <slot name="right-icon" />
    {/if}
  </button>
{/if}

<style lang="postcss">
  .primary {
    @apply bg-mint-dark-4 text-mint-dark-11;
  }
  .primary:hover {
    @apply bg-mint-dark-5;
  }
  .primary:focus {
    @apply border-mint-dark-11 bg-mint-dark-5 ring-mint-dark-8;
  }
  .primary:disabled {
    @apply bg-mint-dark-2 text-mint-dark-7;
  }
  .secondary {
    @apply bg-gray-dark-13 text-gray-dark-1;
  }
  .secondary:hover {
    @apply bg-gray-dark-12;
  }
  .secondary:focus {
    @apply border-mint-dark-8 bg-gray-dark-12 ring-mint-dark-4;
  }
  .secondary:disabled {
    @apply bg-gray-dark-10 text-gray-dark-6;
  }
  .tertiary {
    @apply bg-gray-dark-4 text-gray-dark-12;
  }
  .tertiary:hover {
    @apply bg-gray-dark-5;
  }
  .tertiary:focus {
    @apply border-mint-dark-8 bg-gray-dark-5 ring-mint-dark-4;
  }
  .tertiary:disabled {
    @apply bg-gray-dark-5 text-gray-dark-9;
  }
  .quaternary {
    @apply text-mint-dark-11 bg-transparent;
  }
  .quaternary:hover {
    @apply bg-gray-dark-2;
  }
  .quaternary:focus {
    @apply border-mint-dark-11 bg-mint-dark-5 ring-mint-dark-8;
  }
  .quaternary:disabled {
    @apply text-mint-dark-7 bg-transparent;
  }
  .quinary {
    @apply text-gray-dark-12 bg-transparent;
  }
  .quinary:hover {
    @apply bg-gray-dark-5;
  }
  .quinary:focus {
    @apply border-mint-dark-8 bg-gray-dark-5 ring-mint-dark-4;
  }
  .quinary:disabled {
    @apply bg-gray-dark-5 text-gray-dark-9;
  }
  .transparent {
    @apply text-gray-dark-12 bg-transparent;
  }
  .transparent:hover {
    @apply text-gray-dark-11;
  }
  .transparent:disabled {
    @apply text-gray-dark-9;
  }
  .danger {
    @apply bg-red-dark-4 text-red-dark-11;
  }
  .danger:hover {
    @apply bg-red-dark-5;
  }
  .danger:focus {
    @apply border-red-dark-8 bg-red-dark-5 ring-red-dark-4;
  }
  .danger:disabled {
    @apply bg-red-dark-2 text-red-dark-7;
  }
  .xs {
    @apply h-6;
  }
  .sm {
    @apply px-md h-8;
  }
  .md {
    @apply px-lg h-10;
  }
  .icon {
    @apply aspect-square px-0;
  }
  .disabled {
    @apply pointer-events-none cursor-not-allowed opacity-50;
  }
</style>
